import React, { useMemo } from 'react';
import { ItemListOption } from '@/contexts/item-context-types';
import { Props as ListItemProps } from '@/components/list-item';
import { OrderableItemList } from './orderable-item-list';
import { OrderableItemListItemWithRowQuantity } from './orderable-item-list-item';
import { StyleSheet } from 'react-native';
import { UpdateQuantityFn } from '@/contexts/new-order-actions-context-types';
import { useItemDetailContext } from '@/contexts/item-detail-context';

interface Props {
  listData: ItemListOption[];
  updateQuantity: UpdateQuantityFn;
}

export const EssentialReminderList: React.FC<Props> = ({
  listData,
  updateQuantity,
}) => {
  const { selectItemListOption } = useItemDetailContext();

  const listItemProps = useMemo<Partial<ListItemProps<ItemListOption>>>(() => {
    return {
      onSelect: (listOption) => {
        selectItemListOption(
          listOption,
          {
            source: 'reminder_sheet',
          },
          {
            updateQuantity,
          },
        );
      },
      renderMainContent: (option) => {
        return (
          <OrderableItemListItemWithRowQuantity
            isFocused={false}
            option={option}
            showListView={false}
            source="essential_items_list"
            updateQuantity={updateQuantity}
          />
        );
      },
    };
  }, [selectItemListOption, updateQuantity]);

  return (
    <OrderableItemList
      gridColumnCount={1}
      listData={listData}
      listItemProps={listItemProps}
      listItemSeparatorStyle={styles.separator}
    />
  );
};

const styles = StyleSheet.create({
  separator: {
    marginHorizontal: 16,
  },
});
